// ============================================================
//  src/firebase.js — Inicialización centralizada de Firebase
//  Todas las instancias se crean aquí y se exportan.
//  Los demás módulos importan desde este archivo, no de firebase/app.
// ============================================================

import { initializeApp }  from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore }   from 'firebase/firestore';
import { getFunctions }   from 'firebase/functions';
import { getStorage }     from 'firebase/storage';

// --- Configuración desde variables de entorno (.env) ---
// Vite expone las variables VITE_* en import.meta.env
const configuracionFirebase = {
    apiKey:            import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain:        import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId:         import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket:     import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId:             import.meta.env.VITE_FIREBASE_APP_ID,
};

// --- Inicialización única de la app ---
const appFirebase = initializeApp(configuracionFirebase);

// --- Exportar servicios listos para usar ---
export const auth      = getAuth(appFirebase);
export const db        = getFirestore(appFirebase);
export const functions = getFunctions(appFirebase);
export const storage   = getStorage(appFirebase);

// Forzar persistencia local para que Firebase no necesite
// re-autenticar con popup cuando el token de ID se renueva.
// Sin esto, Chrome bloquea el iframe de firebaseapp.com y Firebase
// cae al popup de "Elige una cuenta" cada ~1 hora.
setPersistence(auth, browserLocalPersistence).catch(console.error);
